import { cn } from '@/lib/utils';
import { Check } from 'lucide-react';

interface GlobalBenefitsBadgeProps {
  hasGlobalBenefits?: boolean;
  className?: string;
  appearance?: 'badge' | 'inline';
}

export function GlobalBenefitsBadge({
  hasGlobalBenefits,
  className,
  appearance = 'badge',
}: GlobalBenefitsBadgeProps) {
  if (!hasGlobalBenefits) return null;

  const isInline = appearance === 'inline';

  return (
    <span
      className={cn(
        'inline-flex w-fit items-center font-medium',
        isInline
          ? 'text-foreground gap-1.5 text-sm'
          : 'min-h-7 justify-center rounded-full border border-blue-200 bg-blue-50 px-3 py-1 text-xs text-blue-700',
        className,
      )}
      data-testid="global-benefits-badge"
    >
      {isInline && <Check className="size-4 shrink-0 text-green-600" />}
      International Benefits
    </span>
  );
}
